import styled from "styled-components";
import { PagesTedsSandboxPageUiInput } from "./Input";
import { PagesTedsSandboxPageUiResults } from "./Results";
import type { tedsSandboxPageAPIInterface } from "@dealer-center/ddc-pages-teds-sandbox-page-interface";

const StyledPagesTedsSandboxPageUi = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const StyledPageHeader = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

interface PagesTedsSandboxPageUiDisplayProps {
  data?: tedsSandboxPageAPIInterface;
  loading: boolean;
  error: Error | null;
  submit: ({ phone, name }: { phone: string; name: string }) => void;
}

export const PagesTedsSandboxPageUiDisplay = ({
  data,
  error,
  loading,
  submit
}: PagesTedsSandboxPageUiDisplayProps) => {
  return (
    <StyledPagesTedsSandboxPageUi>
      <StyledPageHeader>Welcome to tedsSandboxPage-react!</StyledPageHeader>
      <PagesTedsSandboxPageUiInput submit={submit} />
      <PagesTedsSandboxPageUiResults
        data={data}
        error={error}
        loading={loading}
      />
    </StyledPagesTedsSandboxPageUi>
  );
};
